import React, { useState } from 'react';

/**
 * Displays similar Jira tickets for a single deviation row.
 *
 * Props:
 *   tickets: [{ issueKey, title, score, browseUrl, sameSystem, sameContract }] — sorted best-first
 *   onCheckedChange: (issueKey, isChecked) => void — called when a checkbox changes
 */
const SimilarTicketsSuggestion = ({ tickets, onCheckedChange }) => {
  const [checked, setChecked] = useState({});

  if (!tickets || tickets.length === 0) {
    return (
      <div style={{ fontSize: '12px', color: 'var(--ids-palette-neutral-60)', marginTop: '4px' }}>
        Inga liknande ärenden hittades
      </div>
    );
  }

  const toggle = (key) => {
    const next = !checked[key];
    setChecked(prev => ({ ...prev, [key]: next }));
    if (onCheckedChange) onCheckedChange(key, next);
  };

  return (
    <div style={{ marginTop: '8px' }}>
      <div style={{ fontSize: '12px', color: 'var(--ids-palette-neutral-50)', marginBottom: '4px', fontWeight: 600 }}>
        Liknande ärenden:
      </div>
      {tickets.map(ticket => (
        <div
          key={ticket.issueKey}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '13px',
            marginBottom: '4px',
          }}
        >
          <input
            type="checkbox"
            checked={!!checked[ticket.issueKey]}
            onChange={() => toggle(ticket.issueKey)}
            style={{ cursor: 'pointer', flexShrink: 0 }}
            aria-label={`Markera ${ticket.issueKey} som relevant`}
          />
          <a
            href={ticket.browseUrl}
            target="_blank"
            rel="noreferrer"
            style={{ fontWeight: 500, color: 'var(--ids-palette-primary-40)' }}
          >
            {ticket.issueKey}
          </a>
          <span style={{ color: 'var(--ids-palette-neutral-30)' }}>— {ticket.title}</span>
          {ticket.sameSystem && (
            <span style={{
              fontSize: '10px',
              background: 'var(--ids-palette-information-95)',
              color: 'var(--ids-palette-primary-40)',
              borderRadius: '3px',
              padding: '1px 5px',
              flexShrink: 0,
            }}>
              Samma system
            </span>
          )}
          {ticket.sameContract && (
            <span style={{
              fontSize: '10px',
              background: 'var(--ids-palette-information-95)',
              color: 'var(--ids-palette-primary-40)',
              borderRadius: '3px',
              padding: '1px 5px',
              flexShrink: 0,
            }}>
              Samma kontrakt
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default SimilarTicketsSuggestion;
